<template>
  <div style="margin-top: 0px">
    <el-row v-if="roleName_list.includes('飞白一线销售') || roleName_list.includes('飞白经理')">
      <el-col
        v-if="isMobile"
        :style="isMobile ? 'padding: 10px 5px 0;margin-bottom: 5px;box-sizing: border-box;' : 'margin-bottom: 5px;padding-right:5px'"
        :sm="24"
        :lg="12"
      >
        <div class="">
          <div class="card_div" style="">
            <div class="content-titles" style="text-align: left; margin: 0 0px 20px 10px">
              <i class="fa fa-pie-chart"></i>
              设备耗材微观市场
            </div>
            <el-row v-if="roleName_list.includes('飞白一线销售')">
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Flacs/report_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ new_obj.flacsHcoCount ? new_obj.flacsHcoCount : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">本周飞白待填报</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Flacs/report_list_query')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">本月飞白填报查询</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row v-if="roleName_list.includes('飞白经理')">
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Flacs/report_aggregate')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">飞白统计</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row
      v-if="
        roleName_list.includes('一线销售') ||
        roleName_list.includes('小区经理') ||
        roleName_list.includes('大区经理') ||
        roleName_list.includes('产品线负责人') ||
        roleName_list.includes('Leaders')
      "
    >
      <el-col
        v-if="isMobile"
        :style="isMobile ? 'padding: 10px 5px 0;margin-bottom: 5px;box-sizing: border-box;' : 'margin-bottom: 5px;padding-right:5px'"
        :sm="24"
        :lg="12"
      >
        <div class="">
          <div class="card_div" style="">
            <div class="content-titles" style="text-align: left; margin: 0 0px 20px 10px">
              <i class="fa fa-pie-chart"></i>
              晶体微观市场
            </div>
            <el-row v-if="roleName_list.includes('一线销售')" style="">
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #a992e2">
                  <!-- <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  /> -->
                  <i style="position: absolute; color: #eee; font-size: 40px; right: 15px; bottom: 15px" class="el-icon-edit-outline"></i>
                  <div @click="click_link('/Expend/expend_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #eee">
                      {{ new_obj.todayPendingConsumption ? new_obj.todayPendingConsumption : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #eee">今日预估耗用量待填报</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #a992e2">
                  <!-- <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  /> -->
                  <i style="position: absolute; color: #eee; font-size: 40px; right: 15px; bottom: 15px" class="el-icon-edit-outline"></i>
                  <div @click="click_link('/Expend/expend_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #eee">
                      {{ new_obj.todayPendingConsumption ? new_obj.todayPendingConsumption : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #eee">今日预估耗用量待填报</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #a992e2">
                  <!-- <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  /> -->
                  <i style="position: absolute; color: #eee; font-size: 40px; right: 15px; bottom: 15px" class="el-icon-edit-outline"></i>
                  <div @click="click_link('/Expend/expend_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #eee">
                      {{ new_obj.todayPendingConsumption ? new_obj.todayPendingConsumption : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #eee">今日预估耗用量待填报</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #55badf">
                  <!-- <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  /> -->
                  <i style="position: absolute; color: #eee; font-size: 40px; right: 15px; bottom: 15px" class="el-icon-date"></i>
                  <div @click="click_link('/Estimate/approve_view')">
                    <p
                      style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 24px; color: #eee; height: 45px; line-height: 45px"
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #eee">上月晶体预估量</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #55badf">
                  <!-- <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  /> -->
                  <i style="position: absolute; color: #eee; font-size: 40px; right: 15px; bottom: 15px" class="el-icon-date"></i>
                  <div @click="click_link('/Estimate/approve_view')">
                    <p
                      style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 24px; color: #eee; height: 45px; line-height: 45px"
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #eee">上月晶体预估量</p>
                  </div>
                </el-card>
              </el-col>
              <!-- <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/NVBP/cataractnnvmp')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ new_obj.lastWeekPendingSurgeries ? new_obj.lastWeekPendingSurgeries : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">
                      {{ old_Month }}月预估手术量待填报
                    </p>
                  </div>
                </el-card>
              </el-col> -->
            </el-row>
            <el-row v-if="isMobile">
              <el-col v-if="roleName_list.includes('一线销售')" :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Estimate/estimate_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ new_obj.monthlyPendingEstimation ? new_obj.monthlyPendingEstimation : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">本月晶体预估量待填报</p>
                  </div>
                </el-card>
              </el-col>
              <el-col v-if="roleName_list.includes('一线销售')" :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/NVBP/cataractnnvmphco')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #3a5fc9;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      <!-- {{ new_obj.pendingApproval ? new_obj.pendingApproval : 0 }} -->
                      更新
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">医院基础信息</p>
                  </div>
                </el-card>
              </el-col>
              <el-col v-if="roleName_list.includes('一线销售')" :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Expend/expend_list_all_new')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">日耗用量汇总</p>
                  </div>
                </el-card>
              </el-col>
              <el-col v-if="roleName_list.includes('一线销售')" :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Estimate/approve_view')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">上月晶体预估量</p>
                  </div>
                </el-card>
              </el-col>
              <!-- <el-col v-if="user_RoleNmae == '一线销售'" :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/Estimate/estimate_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{
                        new_obj.monthlyEstimationPendingApplications
                          ? new_obj.monthlyEstimationPendingApplications
                          : 0
                      }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">本月晶体预估量申请列表</p>
                  </div>
                </el-card>
              </el-col> -->
              <el-col v-if="roleName_list.includes('一线销售')" :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/NVBP/apply_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{ new_obj.hospitalInfoPendingApplications ? new_obj.hospitalInfoPendingApplications : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">医院基础信息申请列表</p>
                  </div>
                </el-card>
              </el-col>
              <el-col
                v-if="roleName_list.includes('Leaders') || roleName_list.includes('产品线负责人')"
                :xs="24"
                :sm="roleName_list.includes('Leaders') ? 8 : 12"
              >
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/NVBP/data_report')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">NVBP数据报表</p>
                  </div>
                </el-card>
              </el-col>

              <el-col
                v-if="
                  roleName_list.includes('小区经理') ||
                  roleName_list.includes('大区经理') ||
                  roleName_list.includes('产品线负责人') ||
                  roleName_list.includes('Leaders')
                "
                :xs="24"
                :sm="12"
              >
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Expend/expend_list_all_new')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      查看
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">日耗用量汇总</p>
                  </div>
                </el-card>
              </el-col>

              <el-col
                v-if="roleName_list.includes('小区经理') || roleName_list.includes('大区经理') || roleName_list.includes('产品线负责人')"
                :xs="24"
                :sm="12"
              >
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/Estimate/estimate_list_no_approve')">
                    <p
                      style="
                        padding: 0;
                        margin: 0;
                        cursor: pointer;
                        text-align: left;
                        font-size: 24px;
                        color: #e97758;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      <!-- {{ new_obj.pendingApproval ? new_obj.pendingApproval : 0 }} -->
                      审核
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">月度晶体预估量审核列表</p>
                  </div>
                </el-card>
              </el-col>
              <el-col
                v-if="roleName_list.includes('小区经理') || roleName_list.includes('大区经理') || roleName_list.includes('产品线负责人')"
                :xs="24"
                :sm="12"
              >
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/NVBP/no_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{ new_obj.hospitalInfoPendingApprovals ? new_obj.hospitalInfoPendingApprovals : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">医院基础信息审批列表</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- ////////////微观市场-数据收集-PC -->
    <el-row style="margin-bottom: 5px" v-if="!isMobile && (roleName_list.includes('Leaders') || roleName_list.includes('产品线负责人'))">
      <div class="card_div" style="">
        <div class="content-titles" style="text-align: left; margin: 0 0px 20px 10px">
          <i class="fa fa-pie-chart"></i>
          微观市场-数据收集
        </div>
        <el-row>
          <el-col :xs="24" :sm="12">
            <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
              <img
                src="../assets/wicon2.png"
                style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                alt=""
              />
              <div @click="click_link('/NVBP/data_report')">
                <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 24px; color: #e97758; height: 45px; line-height: 45px">
                  查看
                </p>
                <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">NVBP数据报表</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <!-- ////////////HCP信息管理 -->
    <el-row>
      <el-col
        :style="isMobile ? 'padding: 10px 5px 0;margin-bottom: 5px;box-sizing: border-box;' : 'margin-bottom: 5px;padding-right:5px'"
        :sm="24"
        :lg="12"
      >
        <!-- <el-col
        :style="isMobile ? 'padding: 10px 15px 0;margin-bottom: 5px;box-sizing: border-box;' : 'margin-bottom: 5px;padding-right:5px'"
        :sm="24"
        :lg="12"
      > -->
        <div class="">
          <div class="card_div" style="">
            <div class="content-titles" style="text-align: left; margin: 0 0px 20px 10px">
              <i class="fa fa-address-card"></i>
              HCP信息管理
            </div>
            <el-row style="">
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <!-- <i class="fa fa-calendar-minus-o" style="position: absolute;color:rgb(210 232 255);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <!-- <el-image style="width: 100px; height: 100px;position: absolute;color:rgb(210 232 255);font-size:50px;right:0;bottom:10px" src="../assets/wicon1.png"></el-image> -->
                  <div @click="click_link('/HCP/HCP_list_no_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ HcoAndHcpCount.hcpApprovalNo ? HcoAndHcpCount.hcpApprovalNo : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">HCP待审批</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <!-- <i class="fa fa-calendar-times-o" style="position: absolute;color:rgb(255 197 203);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon3.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/HCP/HCP_list_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ HcoAndHcpCount.hcpApprovalReject ? HcoAndHcpCount.hcpApprovalReject : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">HCP已驳回</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <!-- <i class="fa fa-calendar-check-o" style="position: absolute;color:rgb(199 244 176);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon4.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />
                  <div @click="click_link('/HCP/HCP_list_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{ HcoAndHcpCount.hcpApproval ? HcoAndHcpCount.hcpApproval : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">HCP已审批</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <!-- <i class="fa fa-list-alt" style="position: absolute;color:rgb(255 218 173);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/HCP/HCP_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{ HcoAndHcpCount.hcp ? HcoAndHcpCount.hcp : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">HCP列表</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :style="isMobile ? 'padding: 10px 5px 0;margin-bottom: 5px;box-sizing: border-box;' : ''" :sm="24" :lg="12">
        <div class="paddig_lefts2">
          <div class="card_div">
            <div class="content-titles" style="text-align: left; margin: 0 0px 20px 10px">
              <i class="fa fa-h-square"></i>
              医院信息管理
            </div>
            <el-row>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <!-- <i class="fa fa-calendar-minus-o" style="position: absolute;color:rgb(210 232 255);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon1.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/HCO/HCO_list_no_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ HcoAndHcpCount.hcoApprovalNo ? HcoAndHcpCount.hcoApprovalNo : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">医院待审批</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #e7edff">
                  <!-- <i class="fa fa-calendar-times-o" style="position: absolute;color:rgb(255 197 203);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon3.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/HCO/HCO_list_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #3a5fc9">
                      {{ HcoAndHcpCount.hcoApprovalReject ? HcoAndHcpCount.hcoApprovalReject : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #3a5fc9">医院已驳回</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <!-- <i class="fa fa-calendar-check-o" style="position: absolute;color:rgb(199 244 176);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon4.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/HCO/HCO_list_approve')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{ HcoAndHcpCount.hcoApproval ? HcoAndHcpCount.hcoApproval : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">医院已审批</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card class="el_card_st" :shadow="isMobile ? 'never' : 'hover'" style="background-color: #ffeeea">
                  <!-- <i class="fa fa-list-alt" style="position: absolute;color:rgb(255 218 173);font-size:50px;right:0;bottom:10px"></i> -->
                  <img
                    src="../assets/wicon2.png"
                    style="position: absolute; color: rgb(210 232 255); font-size: 50px; right: 15px; bottom: 15px"
                    alt=""
                  />

                  <div @click="click_link('/HCO/HCO_list')">
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 32px; color: #e97758">
                      {{ HcoAndHcpCount.hco ? HcoAndHcpCount.hco : 0 }}
                    </p>
                    <p style="padding: 0; margin: 0; cursor: pointer; text-align: left; font-size: 14px; color: #e97758">医院列表</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 
    <div style="background-color:white;padding:20px 10px;border-radius: 10px;margin-top:10px">
  
   

    </div> -->

    <!-- <el-row>
        <el-col :sm="12" :xs="24" class="echarts-item">
          <div class="content-titles"><i class="fa fa-pie-chart"></i>环形图</div>
          <ve-ring :data="ringChartData" :settings="ringChartSettings"></ve-ring>
        </el-col>
      </el-row> -->

    <!-- <el-row v-if="BUT_IF_LIST.includes('饼图和线图') && !isMobile"> -->
    <!-- <el-col style="margin-bottom: 5px;" :span="10" :xs='24'>
        <div style="background-color:white;border-radius: 5px;overflow: hidden;padding:20px">
          <div class="content-titles"><i class="fa fa-pie-chart"></i>审批状态分布</div>
          <div id="ric_div" style="
          width: 100%;
          height: 400px;
          display: inline-block;
          margin-right: 50px;
        "></div>
        </div>
      </el-col> -->
    <!-- <el-col style="margin-bottom: 5px" :span="24" :xs="24" class="paddig_lefts">
        <div style="background-color: white; border-radius: 5px; overflow: hidden; padding: 20px">
          <div class="content-titles">
            <i class="fa fa-line-chart"></i>
            7日用户访问量
          </div>
          <div id="line_div" style="width: 100%; height: 400px; display: inline-block; margin-right: 50px"></div>
        </div>
      </el-col>
    </el-row> -->

    <!-- </div> -->
    <!-- <div style="background-color:white;padding:20px 10px;border-radius: 10px;margin-top:10px">
        <div class="content-titles" style="font-size:16px;font-weight: bold;margin-left:0;background-color:white;padding:0px 10px;border-radius: 10px;margin-bottom:10px;"> <i class="fa fa-paper-plane"></i>快捷导航
        </div>
    </div> -->
    <div v-if="BUT_IF_LIST.includes('通知') && !isMobile" style="background-color: white; padding: 20px 10px; border-radius: 10px; margin-top: 0px">
      <div
        style="
          font-size: 16px;
          margin-left: 0;
          background-color: white;
          padding: 0px 10px;
          border-radius: 10px;
          margin-bottom: 10px;
          font-weight: bold;
        "
      >
        <i class="fa fa-bell-o"></i>
        站内通知
      </div>
      <ul class="infinite-list" style="overflow: auto; height: 200px; padding: 10px 20px">
        <el-alert v-for="item in users" style="margin-bottom: 10px" type="warning" :closable="false" :description="item.ModifyTime" show-icon>
          <template slot="title">
            <div v-html="item.MsgContent.replace(/\n/g, '<br>')"></div>
          </template>
        </el-alert>
      </ul>
    </div>
    <!-- <div style="background-color:white;padding:20px 10px;border-radius: 10px;margin-top:10px">
      <el-table :data="users" :header-cell-style="{'text-align':'center','color':'#6170d7','backgroundColor':'#F5F7FA'}" :cell-style="{'text-align':'center'}" highlight-current-row
        @current-change="selectCurrentRow" v-loading="listLoading"  >
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column prop="MsgContent" label="通知" width=""></el-table-column>
        <el-table-column prop="ModifyTime" label="时间" width=""></el-table-column>
      </el-table>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue'
// import VCharts from 'v-charts'
// Vue.use(VCharts, VCharts.name)
// import * as echarts from 'echarts';
import * as echarts from 'echarts'
// import { getButtonList } from "../promissionRouter";
import applicationUserManager from '../Auth/applicationusermanager'
import {
  getAccessLogs,
  getIds4UsersGrow,
  getActiveUsers,
  getAchieveUsers_IS4,
  MsgGetPVUV,
  extapi_dashboard_get,
  MsgGetHcoAndHcpCount,
  MsgGetMsgApprovalList,
  MsgQueryPage,
} from '../api/api'
export default {
  name: 'Welcome',
  data() {
    return {
      new_obj: {},
      roleName_list: {},
      old_Month: '',
      now_Month: '',
      user_RoleNmae: '',
      new_obj: {},
      isMobile: false,
      BUT_IF_LIST: [],
      buttonList: [],
      ringChartData: {
        columns: ['日期', '成本', '利润'],
        rows: [
          {
            日期: '1月1号',
            成本: 123,
            利润: 3,
          },
          {
            日期: '1月2号',
            成本: 1223,
            利润: 6,
          },
          {
            日期: '1月3号',
            成本: 2123,
            利润: 90,
          },
          {
            日期: '1月4号',
            成本: 4123,
            利润: 12,
          },
          {
            日期: '1月5号',
            成本: 3123,
            利润: 15,
          },
          {
            日期: '1月6号',
            成本: 7123,
            利润: 20,
          },
        ],
      },
      ringChartSettings: {
        // dimension: "成本",
        // metrics: "利润",
        label: {
          // show: true,
          formatter: '{a}: {d}%',
        },
      },
      HcoAndHcpCount: {},
      listLoading: false,
      welcomeInitData: {
        activeUsers: [],
        activeUserCount: 0,
        logs: [],
        errorCount: 0,
      },
      serverInfo: {},
      extend: {
        series: {
          label: {
            normal: {
              show: true,
            },
          },
        },
      },
      lineChartDataIDS4: {
        columns: [],
        rows: [],
        today: 0,
      },
      pv_uv_list: {},
      approval_list: [],
      users: [],
      lineChartSettings7Day: {
        metrics: ['count'],
        dimension: ['date'],
      },
      lineChartMarkPoint: {
        data: [
          {
            name: '最大值',
            type: 'max',
          },
          {
            name: '最小值',
            type: 'min',
          },
        ],
      },
      colors: [],
    }
  },
  methods: {
    getModules() {
      this.listLoading = true

      MsgGetHcoAndHcpCount().then((res) => {
        this.HcoAndHcpCount = res.data.response
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    click_link(link, num) {
      //   this.$router.push(link)
      this.$router.push({
        path: link,
        query: {
          que: num,
        },
      })
    },
    getTypeName(count) {
      if (count >= 10 && count < 50) {
        return 'warning'
      }
      if (count < 10) {
        return 'primary'
      }
      return 'danger'
    },
    getBck(index) {
      return `background: rgb(${43 + index * 14}, ${148 + index * 7}, 255) none repeat scroll 0% 0%;`
    },
    toLogs() {
      this.$router.replace({
        path: '/Logs/Index',
      })
    },
    myChart() {
      var chartDom = document.getElementById('line_div')
      var myChart = echarts.init(chartDom)
      var option
      option = {
        backgroundColor: '#fff',
        tooltip: { trigger: 'axis' },
        //   tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //       lineStyle: {
        //         color: 'red',
        //       },
        //     },
        //   },
        legend: {
          icon: 'rect',
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 13,
          data: ['PV', 'UV'],
          right: '4%',
          textStyle: {
            fontSize: 12,
            color: '#000',
          },
        },
        // grid: { top: 70, right: 20, bottom: 30, left: 30 },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          top: '10%',
          containLabel: true,
        },
        xAxis: [
          {
            //   type: 'category',
            //   boundaryGap: false,
            //   axisTick: {
            //     show: false,
            //   },
            //   axisLabel: {
            //     margin: 5,
            //     textStyle: {
            //       fontSize: 14,
            //       color: '#000',
            //     },
            //   },
            //   axisLine: {
            //     lineStyle: {
            //       color: '#ddd',
            //     },
            //   },
            //   splitLine: {
            //     // show: true,
            //     lineStyle: {
            //       type: 'dotted',
            //       color: '#ddd',
            //       widt: 1,
            //     },
            //   },
            data: this.pv_uv_list.date,
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: {
              color: '#000',
            },
            minInterval: 1,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ddd',
              },
            },
            axisLabel: {
              margin: 5,
              textStyle: {
                fontSize: 12,
                color: '#000',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#f5f5f5',
              },
            },
          },
        ],
        series: [
          {
            name: 'PV',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            //   showSymbol: false,
            //   lineStyle: { color: '#fe9a8b' },
            // itemStyle: { color: '#fe9a8b', borderColor: '#fe9a8b' },
            //   lineStyle: {
            //     normal: {
            //       width: 3,
            //     },
            //   },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgb(149, 198, 255,0.6)',
                    },
                    {
                      offset: 1,
                      color: 'rgb(149, 198, 255, 0.1)',
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: 'rgb(149, 198, 255)',
              },
            },
            data: this.pv_uv_list.pv,
          },
          {
            name: 'UV',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            //   showSymbol: false,
            //   lineStyle: { color: '#9E87FF' },
            // 		itemStyle: { color: '#9E87FF', borderColor: '#9E87FF' },
            //   lineStyle: {
            //     normal: {
            //       width: 3,
            //     },
            //   },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgb(249, 157, 132,0.6)',
                    },
                    {
                      offset: 1,
                      color: 'rgb(249, 157, 132, 0.1)',
                    },
                  ],
                  false
                ),
              },
            },
            //   emphasis: {
            // 			itemStyle: {
            // 				color: {
            // 					type: 'radial',
            // 					x: 0.5,
            // 					y: 0.5,
            // 					r: 0.5,
            // 					colorStops: [
            // 						{ offset: 0, color: '#9E87FF' },
            // 						{ offset: 0.4, color: '#9E87FF' },
            // 						{ offset: 0.5, color: '#fff' },
            // 						{ offset: 0.7, color: '#fff' },
            // 						{ offset: 0.8, color: '#fff' },
            // 						{ offset: 1, color: '#fff' },
            // 					],
            // 				},
            // 				borderColor: '#9E87FF',
            // 				borderWidth: 2,
            // 			},
            // 		},
            itemStyle: {
              normal: {
                color: 'rgb(249, 157, 132)',
              },
            },
            data: this.pv_uv_list.uv,
          },
        ],
      }
      option && myChart.setOption(option) //通过setOption()方法生成图表
    },
    ric_div_fn() {
      var chartDom = document.getElementById('ric_div')
      var myChart = echarts.init(chartDom)
      var option
      option = {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '5%',
          right: '5%',
          width: 120,
          itemGap: 50,
          //   left: 'center',
          data: this.approval_list,
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84'],
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              normal: {
                show: false,
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: this.approval_list,
          },
        ],
      }
      option && myChart.setOption(option) //通过setOption()方法生成图表
    },
    async MsgGetPVUV_fn() {
      const { data } = await MsgGetPVUV()
      this.pv_uv_list = data.response
      this.myChart()
      console.log(data)
    },
    async MsgGetMsgApprovalList_fn() {
      const { data } = await MsgGetMsgApprovalList()
      this.approval_list = data.response
      // this.myChart()
      this.ric_div_fn()
      console.log(data)
    },
    async extapi_dashboard_get_fn() {
      const {
        data: { data },
      } = await extapi_dashboard_get()
      //   console.log(data)
      //   if (!data.data.roleName) {
      //     this.user_RoleNmae = '其他'
      //     return
      //   }
      let new_obj = {}
      let roleName_list = []
      for (var i in data) {
        roleName_list.push(data[i].roleName)
        new_obj = {
          ...data[i].flacsSummarys,
          ...data[i].managerSummary,
          ...data[i].salesSummary,
        }
      }
      this.roleName_list = roleName_list
      this.new_obj = new_obj
      //   if (data.roleName == '一线销售') {
      //     this.new_obj = data.salesSummary
      //     this.user_RoleNmae = data.roleName
      //   } else {
      //     if (data.data.roleName == '飞白一线销售') {
      //       this.new_obj = data.data.flacsSummarys
      //     } else {
      //       this.new_obj = data.data.managerSummary
      //     }
      //     this.user_RoleNmae = data.data.roleName
      //   }
    },
  },

  mounted() {
    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const old_Month = now.getMonth()
    this.now_Month = currentMonth
    if (old_Month == 0) {
      this.old_Month = 12
    } else {
      this.old_Month = old_Month
    }
    var curTime = new Date()
    if (window.localStorage.TokenExpire) {
      var expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
      if (curTime >= expiretime) {
        if (global.IS_IDS4) {
          applicationUserManager.login()
        } else {
          //   this.$router.push("/login");
          this.$router.push('/jump_link')
          return
        }
      }
    } else {
      if (global.IS_IDS4) {
        applicationUserManager.login()
      } else {
        // this.$router.push("/login");
        this.$router.push('/jump_link')
        return
      }
    }
    this.extapi_dashboard_get_fn()
    this.MsgGetPVUV_fn()
    this.MsgGetMsgApprovalList_fn()
    this.getModules()
    this.isMobile = window.innerWidth <= 767

    MsgQueryPage({ IsDisable: false }).then((res) => {
      this.total = res.data.response.dataCount
      this.users = res.data.response.data
      this.listLoading = false
    })
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    // this.buttonList = getButtonList(this.$route.path, routers);
    console.log(routers)
    var list_cd = []
    if (routers[0].name == '首页') {
      list_cd = routers[0].children
    }
    console.log(list_cd)
    for (var i in list_cd) {
      if (list_cd[i].IsButton) {
        this.BUT_IF_LIST.push(list_cd[i].name)
      }
    }
    console.log(this.BUT_IF_LIST)

    // if (global.IS_IDS4)
    // {
    //   getAchieveUsers_IS4({}).then((res) => {
    //     this.lineChartDataIDS4 = res.data.response;
    //   });
    // }

    // getServerInfo({}).then((res) => {
    //   this.serverInfo = res.data.response;
    // });
  },
}
</script>
<style>
.el-card__body {
  padding: 12px !important;
}
@media (min-width: 768px) {
  .paddig_lefts {
    /* padding-left: 5px; */
    box-sizing: border-box;
  }
}
@media (min-width: 1200px) {
  .paddig_lefts2 {
    /* padding-left: 5px; */
    box-sizing: border-box;
  }
}
</style>
<style scoped>
.content-titles {
  font-size: 16px;
  font-weight: bold;
  color: #38393a;
}
.content-az {
  /* border: 1px solid #fff !important */
}
.card_div {
  background-color: white;
  padding: 20px 10px 20px 10px;
  border-radius: 5px;
  text-align: center;
}
.el_card_st {
  color: #34302d;
  width: 250px;
  display: inline-block;
  margin-right: 50px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
@media (max-width: 768px) {
  .el_card_st {
    color: #34302d;
    width: 100%;
    display: inline-block;
    margin-right: 0px;
    border-radius: 5px;
    position: relative;
    margin-bottom: 3px;
  }
}

.amazing /deep/ .el-badge__content {
  background-color: purple !important;
}
.bg-blue-sub-item {
  max-width: 120px !important;
  height: 50px;
  float: left;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  padding: 0 10px;
}
.bg-blue-sub-item .acc-user {
  max-width: 115px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bg-blue-sub-item-m {
  height: 50px;
  float: left;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  padding: 0 10px;
}
.bg-blue-sub-item-m .acc-user {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.note .text {
  font-size: 14px;
}

.note .item {
  margin-bottom: 18px;
}
</style>

<style scoped>
.panel-group {
  margin-bottom: 18px;
  margin-right: 2%;
}
.card-panel-col {
  /* margin-bottom: 32px; */
  width: 113px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-left: 15px;
  float: right;
}

.card-panel {
  height: 108px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}

.card-panel .card-panel-icon-wrapper {
  color: #fff;
}

.card-panel .card-panel .icon-people {
  background: #40c9c6;
}

.card-panel .card-panel .icon-message {
  background: #36a3f7;
}

.card-panel .card-panel .icon-money {
  background: #f4516c;
}

.card-panel .card-panel .icon-shopping {
  background: #34bfa3;
}

.card-panel .icon-people {
  color: #40c9c6;
}

.card-panel .icon-message {
  color: #36a3f7;
}

.card-panel .icon-money {
  color: #f4516c;
}

.card-panel .icon-shopping {
  color: #34bfa3;
}

.card-panel .card-panel-icon-wrapper {
  float: left;
  margin: 14px 0 0 14px;
  padding: 16px;
  transition: all 0.38s ease-out;
  border-radius: 6px;
}

.card-panel .card-panel-icon {
  float: left;
  font-size: 48px;
}

.card-panel .card-panel-description {
  float: left;
  font-weight: bold;
  margin-left: 30px;
  margin-top: 20px;
}
.card-panel .card-panel-description .card-panel-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
}

.card-panel .card-panel-description .card-panel-num {
  font-size: 36px;
  color: #f4516c;
}
.extoday {
  cursor: pointer;
}
.card-acuser-num {
  font-size: 36px;
  color: #40c9c6;
}
.bg-blue-sub-item /deep/ .el-badge__content.is-fixed {
  top: 5px !important;
}
.bg-blue-sub-item-m /deep/ .el-badge__content.is-fixed {
  top: 5px !important;
}

@media (max-width: 550px) {
  .note50 {
    width: 100% !important;
  }
  .statistical-cus {
    width: 100%;
  }

  .card-panel-col {
    margin-bottom: 5px !important;
    width: 100% !important;
  }
  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }
  .card-panel-icon-wrapper .svg-icon {
    display: block;
    margin: 14px auto !important;
    float: none !important;
  }
}
</style>
